import { __spreadArrays } from "tslib";
// Calculates the general trend graph into a domain of maximum size 10
export var calculateTrend = function (data) {
    var dataValues = data.map(function (dataPoint) { return dataPoint.y; });
    var emptyBuckets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var bucketSize = dataValues.length / emptyBuckets.length;
    var remainingCount = dataValues.length % emptyBuckets.length;
    var filledBuckets = bucketSize > 0 ? emptyBuckets.reduce(function (res, _, idx) {
        var subValues = dataValues.slice(idx * bucketSize, (idx + 1) * bucketSize);
        if (subValues.length) {
            var avg = subValues.reduce(function (r, curr) { return r + curr; }, 0) / subValues.length;
            return __spreadArrays(res, [avg]);
        }
        else {
            return res;
        }
    }, []) : [0];
    var remainingBucket = remainingCount ?
        [dataValues.slice(-remainingCount).reduce(function (res, curr) { return res + curr; }, 0) / remainingCount] : [];
    return __spreadArrays(filledBuckets, remainingBucket).map((function (v, i) { return ({ x: i, y: v }); }));
};
//# sourceMappingURL=calc-trend.js.map